import { Map as iMap, fromJS } from 'immutable';
import * as constants from './integration-constants';
// IMPORTANT NOTE: below hashmaps are not being used in TourplanAPI, even though they are saved in the db
// these are just for explaining purposes
const seasonNameHash = {
  'Peak/High Season': 'Peak',
  'Mid/Shoulder Season': 'Shoulder',
  'Off-Peak/Low Season': 'Low',
  'Special Event': '<Event Name>',
  'Summer': 'Summer',
  'Winter': 'Winter',
  'Spring': 'Spring',
  'Fall/Autumn': 'Fall',
  'Christmas Holidays': 'Xmas',
  'Easter Holidays': 'Easter',
  'New Years Holidays': 'New Years',
  'Chinese/Lunar New Years Holidays': 'Chinese NY',
  'January': 'January',
  'February': 'February',
  'March': 'March',
  'April': 'April',
  'May': 'May',
  'June': 'June',
  'July': 'July',
  'August': 'August',
  'September': 'September',
  'October': 'October',
  'November': 'November',
  'December': 'December',
  '1st Quarter: January - March': 'Q1',
  '2nd Quarter: April - June': 'Q2',
  '3rd Quarter: July - September': 'Q3',
  '4th Quarter: October - December': 'Q4',
  'Standard': 'Standard',
  'Premium': 'Premium',
};

const rateNameHashMap = {
  'Private/Custom': 'Private',
  'Depart/Entry: Morning': 'Morning',
  'Depart/Entry: Afternoon': 'Noon',
  'Depart/Entry: Evening': 'Evening',
  'Depart/Entry: Night': 'Night',
  'Special Event': '<Event Name>',
  'Bed & Breakfast': 'B&B',
  'Bed & Breakfast: Midweek': 'B&BMid',
  'Bed & Breakfast: Weekend': 'B&BWkn',
  'Foreign Language': 'Lang',
  'Nightly': 'Nightly',
  'Nightly: Midweek': 'Midweek',
  'Nightly: Weekend': 'Weekend',
  'Minimum Night Stay': 'Min Night',
  'Extended Stay': 'Extended',
  'Stay Pay': 'SP',
  'Package': 'Package',
  'Group': 'Group',
  'Indicative': 'IND',
};
const rateNameTextInitial = [{
  text: 'Rate Set Name',
  checked: true,
  field: 'rateSetName',
  mappings: rateNameHashMap,
}, {
  text: 'Rate Set Code / Description *',
  checked: true,
  field: 'rateSetCode',
  mappings: { '<User Entered>': '<XX>' },
}, {
  text: 'Season Name',
  checked: false,
  field: 'seasonName',
  mappings: seasonNameHash,
}, {
  text: 'Days of The Week',
  checked: false,
  field: 'daysOfWeek',
  mappings: {
    'Monday': 'M',
    'Tuesday': 'Tu',
    'Wednesday': 'W',
    'Thursday': 'Th',
    'Friday': 'F',
    'Saturday': 'Sa',
    'Sunday': 'Su',
    'Full Week': '',
    'Multiple': 'M-Th',
  },
}, {
  text: 'Min/Max Stay',
  checked: false,
  field: 'minMaxStay',
  mappings: {
    '<User Entered>': '<XX> Nt',
  },
}, {
  text: 'Stay X Pay Y *',
  checked: false,
  field: 'stayPay',
  mappings: {
    '<User Entered>': 'S<X>P<X>',
  },
}];
const initialExportState = {
  convertedContract: [],
  displayExportPreview: false,
  dialogOpen: false,
  editCarriesTo: 'sameSeasonAcrossProducts',
  exportStatus: '',
  exportStep: 1,
  contract: {},
  ratePackageIds: [],
  updatingContractState: false,
};
const initialState = fromJS({
  settings: {
    rateNameUseCombination: true,
    rateNamePopoverOpen: false,
    rateNamePopoverContent: {},
    rateNameAnchorEl: undefined,
    rateTextUseCombination: false,
    rateTextPopoverOpen: false,
    rateTextPopoverContent: {},
    rateTextAnchorEl: undefined,
    rateNameSetting: rateNameTextInitial,
    rateTextSetting: rateNameTextInitial,
    extra1: { selectedExtras: [] },
    extra2: { selectedExtras: [] },
    extra3: { selectedExtras: [] },
    extra4: { selectedExtras: [] },
    extra5: { selectedExtras: [] },
    priceCodesSetting: {
      defaultCode: '',
      rules: [],
      productRules: [],
    },
  },
  ...initialExportState,
});
import { map } from 'ramda';
/*
** ## means currently allow edit in export preview
 convertedContract: [{
 ----** Start forTourplan **---
   forTourplan: [{
      Login:
      Password:
      ----** Start DateRange **---
      DateRange: {
       OptionCode: 'QLDACISMULSISLSUI',
       seasonName: 'Off-Peak/Low Season',
       eventName: null,
       seasonId: 'blackout', // or season index
       Date_From: '2018-04-01',
       Date_To: '2018-04-30',
       Sale_From: '2017-11-16',
       Sale_To: '2049-12-31',
       Buy_Currency: 'AUD',
       Sell_Currency: 'AUD',
       RateSet: [{
 ##Stay_Type: 'Nightly',
 ##Rate_Text: '',
         Min_SCU: 1,
         Max_SCU: 999,
         RateSetStatus: '',
         Apply_Mon: 'Y',
         Apply_Tue: 'Y',
         Apply_Wed: 'Y',
         Apply_Thu: 'Y',
         Apply_Fri: 'Y',
         Apply_Sat: 'Y',
         Apply_Sun: 'Y',
 ##Cancel_Hours: 216,
         GroupCost: { Rates: { RoomRate: {} } },
         FITCost: { Rates: {
           RoomRate: {
             SG: 210,
             TW: 210,
             TR: '0.0000',
             QD: '0.0000',
             AA: '0.0000'
           },
           ChildRate: '0.0000'
         } },
         GroupSell: { Rates: { RoomRate: {} } },
         FITSell: { Rates: { RoomRate: {} } }
       },
      ----** END DateRange **---
   }],
    ----** End forTourplan **---
   mapping,
   productName,
   tourplanName,
   extraLines,
 ##discrepancyMsg
   policies
   historyFeedId
   isAccommodation,
   bedsAndSofas
   productId
 ##pickedExtras
 ##notPickedExtras
 }]
 */
const addOriginalValueInRateSet = convertedContract => {
  return convertedContract.map(product => ({
    ...product,
    forTourplan: product.forTourplan.map(obj => ({
      ...obj,
      DateRange: {
        ...obj.DateRange,
        originalSale_From: obj.DateRange.Sale_From,
        originalSale_To: obj.DateRange.Sale_To,
        originalTaxes: obj.DateRange.Taxes,
        originalPriceCodes: obj.DateRange.PriceCodes,
        RateSet: obj.DateRange.RateSet.map(rateSet => ({
          ...rateSet,
          originalStay_Type: rateSet.Stay_Type,
          originalRate_Text: rateSet.Rate_Text,
          originalCancel_Hours: rateSet.Cancel_Hours,
        })),
      },
    })),
  }));
};
const mergeWithExistingData = (existingArray, newArray) => {
  if (!(newArray && newArray.length)) return existingArray;
  return fromJS(
    newArray.map(newObj => {
      const currentObj = existingArray.toJS().find(o => o.productId === newObj.productId);
      const currentExtraLength = Object.values(currentObj.extraLines).filter(x => x).length;
      const notEnoughAvailExtras = newObj.extraLines && Object.values(newObj.extraLines).filter(x => x).length < currentExtraLength;
      return {
        ...currentObj,
        extraLines: newObj.extraLines,
        policies: newObj.policies,
        pickedExtras: notEnoughAvailExtras ? fromJS(newObj.pickedExtras) : currentObj.pickedExtras,
        notPickedExtras: notEnoughAvailExtras ? fromJS(newObj.notPickedExtras) : currentObj.notPickedExtras,
      };
    })
  );
};

export function integration(state = initialState, action) {
  switch (action.type) {
    case constants.UPDATE_WITH_KEYPATH:
      return state.setIn(action.payload.keyPath, action.payload.immutableValue);
    case constants.GET_CONTRACT_STARTING:
    case constants.GETTING_CONVERTED_CONTRACT:
      return state.set('exportStatus', 'gettingConvertedContract');
    case constants.GET_CONVERTED_CONTRACT:
      return state.set('exportStatus', 'success')
        .set('exportStep', 2)
        .set('convertedContract', fromJS(addOriginalValueInRateSet(action.payload)));
    case constants.GETTING_CONVERTED_CONTRACT_FAILED:
      return state.set('exportStatus', 'failed')
      .setIn(['contract', 'exportError'], `We are experiencing difficulties generating the preview, please try again with just one product. If it still doesn't work, please reach out to us.`)
      .set('dialogOpen', true);
    case constants.GET_CONTRACT:
      return state.set('contract', fromJS(action.integration))
      .set('ratePackageIds', fromJS(action.integration.products.filter(o => o.tourPlanOptionID).map(o => o._id)))
      .set('exportStatus', 'success');
    case constants.CHANGE_INTEGRATION_EXPORT_TYPE:
      return state.updateIn(['contract', 'products'], map(product => {
        if (product.get('productId') === action.payload.productId) return product.set('exportAs', action.payload.value);
        return product;
      }));
    case constants.CLEAR_EXPORT_STATE:
      return state.merge(fromJS(initialExportState));
    case constants.GET_CONTRACT_FAILED:
      return state.set('getContractError', 500);
    case constants.GET_CONTRACTS_STARTING:
      return state.set('loadingContracts', 'loading');
    case constants.GET_CONTRACTS:
      return state.set('contracts', fromJS(action.integration.contracts))
                  .set('totalContractsNo', action.integration.totalNo)
                  .set('loadingContracts', 'success');
    case constants.GET_CONTRACTS_FAILED:
      return state.set('loadingContracts', 'failed');
    case constants.UPDATE_PRODUCT:
      return state.updateIn(['contract', 'products', action.payload.index], prod => prod.merge(action.payload.updater));
    case constants.VALIDATE_MAPPING_STATUS:
      return state.setIn(['contract', 'products', action.key, 'validateMappingStatus'], action.status)
        .setIn(['contract', 'products', action.key, 'validateError'], action.error);
    case constants.VALIDATE_MAPPING:
      return state.setIn(['contract', 'products', action.key, 'tourPlanOptionName'], action.payload.tourPlanOptionName)
        .setIn(['contract', 'products', action.key, 'tourPlanOptionID'], action.payload.tourPlanOptionID)
        .setIn(['contract', 'products', action.key, 'validateMappingStatus'], action.status)
        .setIn(['contract', 'products', action.key, 'hasRates'], action.payload.hasRates)
        .setIn(['contract', 'products', action.key, 'validateError'], '')
        .update('ratePackageIds', arr => {
          const rpId = state.getIn(['contract', 'products', action.key, '_id']);
          if (action.payload.tourPlanOptionID && arr.indexOf(rpId) === -1) {
            return arr.push(rpId);
          }
          if (!action.payload.tourPlanOptionID && arr.indexOf(rpId) > -1) {
            return arr.filter(id => id !== rpId);
          }
          return arr;
        })
        .update('convertedContract', convertedArray => {
          if (
            convertedArray && convertedArray.size
            && !action.payload.hasRates
            && !action.error
            && action.status === 'ready'
            && action.payload.tourPlanOptionID
          ) {
            return convertedArray.map(obj => {
              if (obj.get('productId') === action.payload.productId) {
                return obj.set('mapping', action.payload.tourPlanOptionID)
                          .set('tourplanName', action.payload.tourPlanOptionName)
                          .update('forTourplan', array => array.map(dr => dr.setIn(['DateRange', 'OptionCode'], action.payload.tourPlanOptionID)));
              }
              return obj;
            });
          }
          return convertedArray;
        });
    case constants.CHECK_RATES_STARTING:
      return state.setIn(['contract', 'products', action.key, 'hasRates'], action.hasRates)
        .set('exportStatus', 'checkingRates');
    case constants.CHECK_IF_HAS_RATES_FAILED:
      return state.set('exportStatus', 'success');
    case constants.CHECK_IF_HAS_RATES:
      return state.setIn(['contract', 'products', action.key, 'hasRates'], action.hasRates)
        .set('exportStatus', 'success');
    case '{integration-export} START':
      return state.set('exportStatus', 'exporting');
    case '{integration-export} GET_PROCESSED_RESPONSE':
    case constants.ADD_MAPPING:
      return state.set('exportStatus', 'success')
        .setIn(['contract', 'exportResponses'], action.payload)
        .set('exportStep', 3);
    case '{integration-export} HANDLE_POLLING_FAILURE':
    case constants.ADD_MAPPING_FAILED:
      return state.set('exportStatus', 'failed')
                  .setIn(['contract', 'exportError'], action.error)
                  .set('dialogOpen', true);
    case constants.GET_AUTH:
      return state.set('auth', fromJS(action.auth));
    case constants.GET_AUTH_FAILED:
      return state.set('authError', fromJS(action.payload));
    case constants.LOGIN:
      return state.set('loginResponse', fromJS(action.payload));
    case constants.UPDATE_SETTINS:
      return state.update('settings', settings => settings.merge(fromJS(action.payload)));
    case 'CHECK_ALL_RATE_PACKAGE_FOR_TOURPLAN_EXPORT':
      return state.update('ratePackageIds', () => {
        if (action.payload.checked) return state.getIn(['contract', 'products']).map(o => o.get('_id'));
        return fromJS([]);
      });
    case 'CHECK_A_RATE_PACKAGE_FOR_TOURPLAN_EXPORT':
      return state.update('ratePackageIds', arr => {
        if (action.payload.checked) {
          if (!action.payload.hasRates || window.confirm('This product already has rates in Tourplan, are you sure you want to overwrite the rates?')) {
            return arr.push(action.payload.ratePackageId);
          }
          return arr;
        }
        return arr.filter(str => str !== action.payload.ratePackageId);
      });
    case '{TP_Integration}CHANGE_CONTRACT_STATE_STARTING':
      return state.set('updatingContractState', true);
    case '{TP_Integration}CHANGE_CONTRACT_STATE_SUCCESS':
      return state.set('updatingContractState', false)
        .setIn(['contract', 'state'], 'loaded');
    case '{TP_Integration}CHANGE_CONTRACT_STATE_ERROR':
      return state.set('updatingContractState', false);
    case constants.CLEAR_INTEGRATION_STORE:
      return initialState;
    case constants.CLEAR_STORES:
    case constants.LOG_OUT:
      return initialState;
    default:
      return state;
  }
}




// WEBPACK FOOTER //
// ./src/app/stores/integration/integration-reducer.js